import type { RemotePattern } from "next/dist/shared/lib/image-config";

export const IMAGE_REMOTE_PATTERNS = [
  { hostname: "lh3.googleusercontent.com" },
  { hostname: "api.repackify.com" },
  { hostname: "*.convex.cloud" },
] as const satisfies ReadonlyArray<Pick<RemotePattern, "hostname">>;

function hostnameMatches(pattern: string, hostname: string): boolean {
  const patternLabels = pattern.split(".");
  const hostLabels = hostname.split(".");
  return patternLabels.length === hostLabels.length &&
    patternLabels.every((label, index) => {
      const hostLabel = hostLabels[index] ?? "";
      return label === "*" ? hostLabel.length > 0 : label === hostLabel;
    });
}

export function isRemoteImageUrl(url: URL): boolean {
  return (url.protocol === "https:" || url.protocol === "http:") &&
    IMAGE_REMOTE_PATTERNS.some((pattern) => hostnameMatches(pattern.hostname, url.hostname));
}
